class LocalStorage {

  get (key) {
    if (typeof window === 'undefined' || !localStorage) return null;
    const value = localStorage.getItem(key);
    if (!value || value === 'undefined') return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  set (key, value) {
    localStorage && localStorage.setItem(key, JSON.stringify(value));
  }

  remove (key, value) {
    // if remove func have a value, this method deletes the value from the object
    if (value) {
      const item = JSON.parse(localStorage.getItem(key));

      if (item) {
        delete item[value];
        localStorage.setItem(key, JSON.stringify(item));
      }
  
      // else, this method deletes the all object
    } else {
      localStorage && localStorage.removeItem(key);
    }
  }

  clear () {
    localStorage && localStorage.clear();
  }

}

export default new LocalStorage();